import type { JSX } from 'solid-js';
import { Show } from 'solid-js';
import { t } from '../i18n';
import type { PagedList } from '../lib/paged';
import { Button } from './ui/Button';

// The one "Load more" affordance for every cursor-paginated list (slice 06).
// Mounted only while the server says there IS another page, and disabled while
// one is in flight — the button is the honest end of `usePagedQuery`'s sticky
// cursor, so it never flickers out mid-fetch. A next page that ERRORED is said
// here, under the rows it must not blank (`paged-view.ts`), and the button
// becomes the retry: `loadMore()` re-reads the failed page.

export function LoadMore<T>(props: {
  readonly list: PagedList<T>;
  /** Override the generic label where a list has a more specific one. */
  readonly label?: string;
}): JSX.Element {
  return (
    <Show when={props.list.hasMore()}>
      <div class="load-more">
        <Button
          variant="outline"
          size="sm"
          disabled={props.list.isFetching()}
          onClick={() => props.list.loadMore()}
        >
          {props.list.loadMoreFailed() ? t('errors.retry') : (props.label ?? t('states.load_more'))}
        </Button>
        <Show when={props.list.loadMoreFailed()}>
          <p class="field__error" role="alert">
            {t('states.load_more_failed')}
          </p>
        </Show>
      </div>
    </Show>
  );
}
